import { toastError } from '@components/Toast';

import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const uploadProductDocument = (id, params, setLoader) => async (dispatch) => {
	await ApiClient.POST('uploadProductDocument', params, id)
		.then(async () => {
			await dispatch(fetchProductInfo(id, setLoader));
		})
		.catch((err) => {
			if (err?.response?.data?.message) {
				toastError(err?.response?.data?.message);
			} else {
				toastError('Something went wrong!');
			}
			if (setLoader) {
				setLoader(false);
			}
		});
};

export const fetchProductInfo = (params, setLoader) => async (dispatch) => {
	await ApiClient.GET('fetchProductInfo', params)
		.then((response) => {
			dispatch({
				type: Types.FETCH_DESIGN_INFO,
				payload: JSON.parse(JSON.stringify(response.data))
			});
			if (setLoader) {
				setLoader(false);
			}
		})
		.catch((err) => {
			toastError(err?.response?.data?.message || 'Something went wrong!');
			if (setLoader) {
				setLoader(false);
			}
		});
};

export const deleteProductDocument = (productId, docId) => async (dispatch) => {
	await ApiClient.DELETE('deleteProductDocument', '', `${productId}/${docId}`).then(async (response) => {
		await dispatch({
			type: Types.DELETE_DESIGN_TOOL_DOCUMENT,
			payload: response.data
		});
	});
};

export const fetchDesignToolComment =
	(id, params = '?sort=id,desc&size=1000') =>
	async (dispatch) => {
		await ApiClient.GET('fetchAllDesignComment', id + params).then((response) => {
			dispatch({
				type: Types.FETCH_DESIGN_TOOL_COMMENT,
				payload: response.data
			});
		});
	};

export const productWiseGroupDocument = (productId) => async (dispatch) => {
	await ApiClient.GET('getGroupwiseDoc', productId).then((response) => {
		dispatch({
			type: Types.FETCH_PRODUCT_WISE_DOCUMENT,
			payload: response.data
		});
	});
};

export const getMemberList = () => async (dispatch) => {
	let params = '?isNitexUser=true&page=0&size=500';
	await ApiClient.GET('getUserSuggestions', params)
		.then(({ data }) => {
			let memberList = [];
			for (let item of data) {
				memberList.push({
					id: item.email,
					email: item.email,
					value: item.name,
					memberId: item.id
				});
			}
			dispatch({
				type: Types.FETCH_DESIGN_TOOL_MEMBERS,
				payload: memberList
			});
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			}
		});
};

export const clearDesignTool = () => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_DESIGN_TOOL,
		payload: {}
	});
};
